import { Component, DestroyRef, effect, inject, Injector, input, OnInit } from '@angular/core';
import { OrgAdminEndpointsService } from '../../../../services/org-service/org-admin-endpoints.service';
import { catchError, finalize, tap } from 'rxjs';
import { ConnectionDto } from '../../org-model/connection-dto.interface';
import { DatePipe } from '@angular/common';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatNoDataRow,
  MatRow,
  MatRowDef,
  MatTable,
  MatTableDataSource
} from '@angular/material/table';
import { SnackbarService } from '../../../../services/snackbar/snackbar.service';
import { NgxSkeletonLoaderComponent } from 'ngx-skeleton-loader';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SessionDetailsTestIds } from './session-details.test-ids';

@Component({
  selector: 'app-session-details',
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderCellDef,
    MatCell,
    MatCellDef,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    DatePipe,
    NgxSkeletonLoaderComponent,
    MatNoDataRow
  ],
  templateUrl: './session-details.component.html',
  styleUrl: './session-details.component.scss'
})
/**
 * Die SessionDetailsComponent-Klasse zeigt in einer Tabelle die Sitzungsdetails
 * eines bestimmten Benutzers innerhalb der Domäne an.
 *
 * Umgesetzte Anforderung: A_25472-01, Aktive und inaktive Sessions anzeigen
 */
export class SessionDetailsComponent implements OnInit {
  userId = input.required<string>();
  domain = input.required<string>();
  isLoading = false;
  sessionDataSource = new MatTableDataSource<ConnectionDto>();
  skeletonData = new Array(5).fill({});
  displayedColumns: string[] = ['ip', 'lastSeen', 'useragent'];
  protected readonly testIds = SessionDetailsTestIds;
  private readonly orgAdminEndpointsService = inject(OrgAdminEndpointsService);
  private readonly injector = inject(Injector);
  private readonly snackbarService = inject(SnackbarService);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    effect(
      () => {
        this.loadSessions();
      },
      { injector: this.injector }
    );
  }
  private loadSessions(): void {
    this.isLoading = true;
    this.orgAdminEndpointsService
      .getSessionsFromUser(this.domain(), this.userId())
      .pipe(
        tap(result => {
          this.sessionDataSource.data = result.result.devices[''].sessions[0].connections;
        }),
        catchError(() => {
          this.isLoading = false;
          this.snackbarService.error('Beim laden der Sessions kam es zu einem Fehler');
          throw new Error('Couldnt load Sessions');
        }),
        finalize(() => (this.isLoading = false)),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
}
